<template>
  <form data-component="payment-buttons" @submit.prevent="submitPayment">
    <div data-element="form-row">
      <div ref="dropin" id="dropin-container"></div>
      <btn
        v-if="showPayButton"
        :loading="loading"
        size="full"
        text="Pay now"
        :fontStyle="{
          ...this.$store.getters['ui/getBodyCopyFontDetail']('normal'),
          textSize: '18px',
        }"
        :backgroundColor="$store.getters['ui/getSecondaryColor']"
      />
    </div>
  </form>
</template>

<script>
import Btn from "@/components/ui/Btn";
import * as dropin from "braintree-web-drop-in";
import { mapGetters } from "vuex";
export default {
  props: [
    "options",
    "successcb",
    "failurecb",
    "salesData",
    "tableNumber",
    "location",
  ],
  components: {
    Btn,
  },
  data() {
    return {
      showPayButton: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({ site: "getSite" }),
  },
  methods: {
    async submitPayment() {
      this.instance.requestPaymentMethod(this.handlePaymentSubmit);
      this.loading = true;
    },
    async handlePaymentSubmit(requestPaymentMethodErr, payload) {
      if (requestPaymentMethodErr) {
        this.instance.clearSelectedPaymentMethod();
        return;
      }
      this.submitPaymentToPos(payload);
    },
    async authenticateUser() {
      this.$store.dispatch("iOrderCheckout/hideModal");
      this.$store.dispatch("iOrderCheckout/showLoginModal");
    },
    async submitPaymentToPos(payload) {
      const slug = this.$route.params.slug;
      const payment = await this.$store.dispatch(
        "iOrderCheckout/makeBraintreePayment",
        {
          salesData: this.$store.getters["iOrderCore/getRequiredSalesData"],
          user: this.$store.getters["iOrderCheckout/getCurrentUser"],
          ...payload,
        }
      );
      if (payment.success) {
        this.successcb();
        return;
      }
      if (payment.status == "authRequired") {
        this.authenticateUser();
        return;
      }
      this.failurecb();
    },
    async init() {
      const token = this.options.btToken;
      const total = this.options.basketTotal.toString();
      const { location, site } = this;
      const {
        googlePayMerchantId,
        hideApplePay,
        hideGooglePay,
        hidePaypal,
      } = site;
      const recipientName = this.tableNumber
        ? `S2S Table ${this.tableNumber}, ${location.brandName}`
        : `S2S ${location.brandName}`;
      dropin
        .create({
          paymentOptionPriority: ["applePay", "googlePay", "paypal", "card"],
          authorization: token,
          container: this.$refs.dropin,
          dataCollector: {
            kount: true,
          },
          threeDSecure: {
            amount: total,
          },
          paypal: !hidePaypal && {
            displayName: "COAT",
            amount: total,
            flow: "checkout",
            intent: "sale",
            currency: "GBP",
            local: "en_GB",
            buttonStyle: {
              shape: "rect",
              size: "responsive",
            },
            commit: true,
            enableShippingAddress: true,
            shippingAddressEditable: false,
            shippingAddressOverride: {
              recipientName,
              countryCode: "GB",
              line1: location.addressLine1 || "",
              city: location.city || "",
              postalCode: location.postalCode || "TestSite",
              state: location.region || "",
            },
          },
          applePay: !hideApplePay && {
            displayName: "COAT",
            paymentRequest: {
              total: {
                label: "Basket Total",
                amount: total,
              },
            },
          },
          googlePay: !hideGooglePay &&
            googlePayMerchantId && {
              googlePayVersion: 2,
              merchantId: googlePayMerchantId,
              transactionInfo: {
                totalPriceStatus: "FINAL",
                totalPrice: total,
                currencyCode: "GBP",
              },
            },
        })
        .then((instance) => {
          this.instance = instance;
          instance.on("paymentOptionSelected", ({ paymentOption }) => {
            const paymentMethodRequestable = this.instance.isPaymentMethodRequestable();
            this.showPayButton = false;
            if (paymentOption === "card" && paymentMethodRequestable) {
              this.showPayButton = true;
            }
          });
          instance.on(
            "paymentMethodRequestable",
            ({ paymentMethodIsSelected, type }) => {
              if (paymentMethodIsSelected && type !== "CreditCard") {
                this.submitPayment();
                this.loading = true;
              }
              this.showPayButton = true;
            }
          );
          instance.on("noPaymentMethodRequestable", () => {
            this.showPayButton = false;
          });
        })
        .catch((err) => {
          console.log(err);
          this.$store.dispatch("iOrderCheckout/hideModal");
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped></style>
